import { CASE_STUDY_SECTION_IDS, caseStudySectionIdToHash } from '@/domain/caseStudySectionAnchors'

export type TocItem = { label: string; anchor: string; depth?: number }

/** Default Content Sheet when `content_sheet.items` is empty but enabled. */
export const defaultCaseStudyTocItems: TocItem[] = [
  { label: 'Overview', anchor: caseStudySectionIdToHash(CASE_STUDY_SECTION_IDS.hero), depth: 0 },
  { label: 'TL;DR', anchor: caseStudySectionIdToHash(CASE_STUDY_SECTION_IDS.tldr), depth: 0 },
  { label: 'Quote', anchor: caseStudySectionIdToHash(CASE_STUDY_SECTION_IDS.quote), depth: 0 },
  { label: 'Problem', anchor: caseStudySectionIdToHash(CASE_STUDY_SECTION_IDS.problem), depth: 0 },
  { label: 'Old workflow', anchor: caseStudySectionIdToHash(CASE_STUDY_SECTION_IDS.oldWorkflow), depth: 0 },
  { label: 'Reframing', anchor: caseStudySectionIdToHash(CASE_STUDY_SECTION_IDS.reframing), depth: 0 },
  { label: 'Solution', anchor: caseStudySectionIdToHash(CASE_STUDY_SECTION_IDS.solution), depth: 0 },
  { label: 'Workflow schema', anchor: caseStudySectionIdToHash(CASE_STUDY_SECTION_IDS.workflowSchema), depth: 1 },
  { label: 'Before / after', anchor: caseStudySectionIdToHash(CASE_STUDY_SECTION_IDS.beforeAfter), depth: 0 },
  { label: 'Impact', anchor: caseStudySectionIdToHash(CASE_STUDY_SECTION_IDS.impact), depth: 0 },
  { label: 'Transferability', anchor: caseStudySectionIdToHash(CASE_STUDY_SECTION_IDS.transferability), depth: 0 },
  { label: 'Gift', anchor: caseStudySectionIdToHash(CASE_STUDY_SECTION_IDS.gift), depth: 0 },
  { label: 'FAQ', anchor: caseStudySectionIdToHash(CASE_STUDY_SECTION_IDS.faq), depth: 0 },
]
